import React, { Component } from "react";
import { apiUrl } from "../../comps/apiUrl";
import { toast } from "react-toastify";
import { Button } from "@mui/material";
import { Delete, Save, TramSharp, trash } from "@mui/icons-material";
class AssinaturaDigital extends Component {
  constructor(props) {
    super(props);

    this.canvasRef = React.createRef();
    this.containerRef = React.createRef(); // Ref para o container pai
    this.state = {
      assinado: false,
      isDrawing: false,
      loader: true,
      error: false,
      errorMessage: "",
      data: [],
    };
    this.ctx = null;
    this.drawing = false; // Flag para rastrear o desenho
  }

  // --- 1. Inicialização do Canvas e Ajuste de Tamanho ---
  // --- 1. Inicialização do Canvas e Ajuste de Tamanho ---
  componentDidMount() {
    fetch(
      `${apiUrl}/verificar/assinatura/` +
      window.location.pathname.split("/").pop(),
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }
    ).then((response) => {
      if (response.status == 404) {
        this.setState({
          loader: false,
          error: true,
          errorMessage: "Documento não encontrado.",
        });
        return;
      }

      if (response.status == 409) {
        this.setState({
          loader: false,
          error: true,
          errorMessage:
            "Este documento já foi assinado e não pode ser modificado.",
        });
        return;
      }

      response.json().then((data) => {
        // --- CHANGE IS HERE ---
        // Use setState's callback to ensure initializeCanvas runs *after*
        // the state update has finished and the component has re-rendered
        // (i.e., when loader is false and the canvas/container are in the DOM).
        this.setState(
          {
            data: data,
            loader: false,
          },
          () => {
            // Now that loader is false, the render() method has returned the
            // canvas and container, and their refs are properly set.
            this.initializeCanvas();
            window.addEventListener("resize", this.resizeCanvas);
          }
        );
      });
    });
  }

  // Limpa o listener de redimensionamento ao desmontar
  componentWillUnmount() {
    window.removeEventListener("resize", this.resizeCanvas);
  }

  // Inicializa o contexto e as dimensões do canvas
  initializeCanvas = () => {
    const canvas = this.canvasRef.current;
    const container = this.containerRef.current;

    // Define o tamanho real (Pixel Density) para evitar borrões
    const ratio = Math.max(window.devicePixelRatio || 1, 1);

    // Ajusta o canvas para o tamanho do contêiner (100% da largura)
    canvas.width = container.offsetWidth * ratio;
    canvas.height = container.offsetHeight * ratio;
    canvas.style.width = container.offsetWidth + "px";
    canvas.style.height = container.offsetHeight + "px";

    this.ctx = canvas.getContext("2d");
    this.ctx.scale(ratio, ratio); // Escala o contexto para a densidade de pixel

    // Configurações do pincel
    this.ctx.lineWidth = 2;
    this.ctx.lineCap = "round";
    this.ctx.strokeStyle = "#000";

    // Garante que o canvas esteja limpo e com fundo branco
    this.ctx.fillStyle = "white";
    this.ctx.fillRect(0, 0, canvas.width, canvas.height);
  };

  // Função para lidar com o redimensionamento do navegador/orientação do celular
  resizeCanvas = () => {
    // Reajusta o tamanho e reinicializa o desenho (isso apaga a assinatura atual)
    // Se precisar manter a assinatura, você precisaria armazenar os pontos e redesenhá-los.
    this.initializeCanvas();
    // Uma notificação para o usuário seria ideal: "A assinatura foi apagada devido à mudança de tamanho."
  };

  // --- 2. Funções de Desenho para Mouse e Toque ---

  getCanvasCoordinates = (e) => {
    const canvas = this.canvasRef.current;
    const rect = canvas.getBoundingClientRect();

    // Detecta se é um evento de toque (touch) ou mouse
    const clientX = e.touches ? e.touches[0].clientX : e.clientX;
    const clientY = e.touches ? e.touches[0].clientY : e.clientY;

    return {
      offsetX: clientX - rect.left,
      offsetY: clientY - rect.top,
    };
  };

  handleStart = (e) => {
    e.preventDefault(); // Impede o scroll e o zoom em dispositivos móveis
    this.drawing = true;

    this.ctx.beginPath();
    const { offsetX, offsetY } = this.getCanvasCoordinates(e);
    this.ctx.moveTo(offsetX, offsetY);
  };

  handleMove = (e) => {
    if (!this.drawing) return;

    e.preventDefault(); // Impede o scroll e o zoom
    const { offsetX, offsetY } = this.getCanvasCoordinates(e);
    this.ctx.lineTo(offsetX, offsetY);
    this.ctx.stroke();
  };

  handleEnd = () => {
    this.drawing = false;
  };

  // --- 3. Funções de Ação (Enviar e Limpar) ---

  enviarAssinatura = () => {
    const canvas = this.canvasRef.current;
    // Verifica se o canvas está em branco
    if (
      this.ctx
        .getImageData(0, 0, canvas.width, canvas.height)
        .data.every((channel) => channel === 255 || channel === 0)
    ) {
      alert("Por favor, assine no campo indicado antes de enviar.");
      return;
    }

    // 1. Converte o conteúdo do canvas para uma URL de dados
    const dataURL = canvas.toDataURL("image/png");

    console.log(
      "Assinatura Capturada (Base64):",
      dataURL.substring(0, 100) + "..."
    );

    fetch(`${apiUrl}/salvar/assinatura`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        assinatura: {
          locatario: dataURL
        },
        token: window.location.pathname.split("/").pop(),
      }),
    })
      .then((response) => {
        if (response.status === 200) {
          this.setState({ assinado: true });
        } else {
          toast.error("Ocorreu um erro ao enviar a assinatura");
        }
      })
      .catch((error) => {
        toast.error("Ocorreu um erro ao carregar as maquinas");
      });

    this.limparAssinatura();
  };

  limparAssinatura = () => {
    this.ctx.clearRect(
      0,
      0,
      this.canvasRef.current.width,
      this.canvasRef.current.height
    );
    this.ctx.fillStyle = "white";
    this.ctx.fillRect(
      0,
      0,
      this.canvasRef.current.width,
      this.canvasRef.current.height
    );
  };

  render() {
    if (this.state.loader) {
      return (
        <div class="area-loader">
          <div class="loader"></div>
        </div>
      );
    }
    if (this.state.assinado) {
      return (
        <div
          style={{
            display: "flex",
            textAlign: "center",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
            height: "100vh",
          }}
        >
          <span style={{ color: "green", fontSize: "20px" }}>
            Assinatura salva com sucesso!
          </span>
        </div>
      );
    }
    if (this.state.error) {
      return (
        <div
          style={{
            display: "flex",
            textAlign: "center",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
            height: "100vh",
          }}
        >
          <span style={{ color: "red", fontSize: "20px" }}>
            {this.state.errorMessage}
          </span>
        </div>
      );
    }
    return (
      <div style={containerStyle}>
        <h2>Assinatura Digital</h2>
        <p>Desenhe sua assinatura abaixo. Funciona por toque!</p>

        {/* Contêiner que define o tamanho do canvas (100% da largura, altura fixa) */}
        <div ref={this.containerRef} style={canvasContainerStyle}>
          <canvas
            ref={this.canvasRef}
            style={canvasStyle}
            // Eventos do Mouse
            onMouseDown={this.handleStart}
            onMouseMove={this.handleMove}
            onMouseUp={this.handleEnd}
            onMouseLeave={this.handleEnd}
            // Eventos de Toque (para dispositivos móveis)
            onTouchStart={this.handleStart}
            onTouchMove={this.handleMove}
            onTouchEnd={this.handleEnd}
          />
        </div>

        {/* Botões de Ação */}
        <div style={{ marginTop: "15px", display: "flex", gap: "10px" }}>
          <Button
            variant="contained"
            color="primary"
            startIcon={<Save />}
            onClick={this.enviarAssinatura}
            style={{ ...buttonStyle, flexGrow: 1 }} // Faz o botão preencher o espaço
          >
            Salvar
          </Button>

          <Button
            variant="contained"
            color="error"
            startIcon={<Delete />}
            onClick={this.limparAssinatura}
          >
            Limpar
          </Button>
        </div>
      </div>
    );
  }
}

// Estilos de Responsividade

const containerStyle = {
  padding: "20px",
  maxWidth: "600px",
  margin: "auto",
  textAlign: "center",
};

const canvasContainerStyle = {
  width: "100%", // 100% da largura do contêiner pai
  height: "200px", // Altura fixa, você pode ajustar
  border: "2px solid #000",
  borderRadius: "5px",
  overflow: "hidden", // Evita quebra de layout
};

const canvasStyle = {
  width: "100%", // O CSS do canvas ocupa 100% do container
  height: "100%",
  cursor: "crosshair",
  backgroundColor: "white",
  // Evita o menu de contexto ao pressionar e segurar
  touchAction: "none",
};

const buttonStyle = {
  padding: "12px 20px",
  backgroundColor: "#1976D2",
  color: "white",
  border: "none",
  borderRadius: "5px",
  cursor: "pointer",
  fontSize: "16px",
  fontWeight: "bold",
};

export default AssinaturaDigital;
